module.exports = new __parcel__URL__("nac-company.269e0029.png").toString();